function MappedInMap({
    url
}) {

	return (
		<div className="MappedInMap" style={{ flex: '1 1 0', minHeight: 0 }}>
            <iframe width={'100%'} height={'100%'} src={url} />
		</div>
	);
}

export default MappedInMap
